import { useMsal } from '@azure/msal-react';

export interface CurrentAccount {
  /** Display name from the token, falling back to the sign-in name when absent. */
  name: string;
  username: string;
}

/** The signed-in account, or null when nobody is signed in. */
export function useCurrentAccount(): CurrentAccount | null {
  const { accounts } = useMsal();
  const account = accounts[0];
  if (!account) return null;
  return { name: account.name ?? account.username, username: account.username };
}
